import { useEffect, useState } from "react";
import classNames from "classnames";
import { FiCheck } from "react-icons/fi";
import { useRouter } from "next/router";
import { BottomSheet } from "../../../components/modals/bottom-sheet/bottom-sheet";
import { normalizeUrl } from "../../../utils/helper";
import { SellerPageRouter } from "../page-router.props";
import { ProductListSortOption } from "../../../utils/interfaces";

const SORT_SETTINGS = [
  {
    value: {
      order_by: "bought",
      sort_by: "asc",
    },
    label: "Terlaris",
  },
  {
    value: {
      order_by: "price",
      sort_by: "asc",
    },
    label: "Harga Terendah",
  },
  {
    value: {
      order_by: "price",
      sort_by: "desc",
    },
    label: "Harga Tertinggi",
  },
  {
    value: {
      order_by: "name",
      sort_by: "asc",
    },
    label: "Urutkan dari A ke Z",
  },
];

interface SortSettingsSheetProps {
  visible: boolean;
  onDismiss: () => void;
  onSubmitSort: (selectedSortOption: ProductListSortOption) => void;
}

export const SortSettingsSheet = ({
  visible,
  onDismiss,
  onSubmitSort,
}: SortSettingsSheetProps) => {
  const [selectedSortOption, setSelectedSortOption] =
    useState<ProductListSortOption>(null);
  const router: SellerPageRouter = useRouter();

  useEffect(() => {
    if (router.query.order_by && router.query.sort_by) {
      setSelectedSortOption({
        order_by: String(router.query.order_by),
        sort_by: String(router.query.sort_by),
      });
    } else {
      setSelectedSortOption(null);
    }
  }, [router.query.order_by, router.query.sort_by]);

  const handleSubmitSort = () => {
    onSubmitSort(selectedSortOption);
  };

  return (
    <BottomSheet visible={visible} onDismiss={onDismiss}>
      <div className="flex justify-between mb-4">
        <div className="text-label-lg font-medium">Urutkan</div>
        <button
          className="text-label-lg text-primary"
          onClick={() => setSelectedSortOption(null)}
          id="product-sort-sheet-reset-btn"
          data-testid="product-sort-sheet-reset-btn"
        >
          Reset
        </button>
      </div>
      {SORT_SETTINGS.map((setting, index) => {
        const isSelected =
          JSON.stringify(selectedSortOption) === JSON.stringify(setting.value);
        const selectedClass = isSelected ? "text-primary" : "text-dark-gray";
        return (
          <div className="relative py-3" key={index}>
            <div
              className={classNames(
                "cursor-pointer text-label-md",
                selectedClass
              )}
              onClick={() => setSelectedSortOption(setting.value)}
              id="product-sheet-sort-option-btn"
              data-testid="product-sheet-sort-option-btn"
            >
              {setting.label}
            </div>
            {isSelected && (
              <FiCheck
                className="absolute inset-y-0 right-0 my-auto text-primary"
                size={16}
              />
            )}
          </div>
        );
      })}
      <button
        className="px-6 py-3 my-2 w-full text-center text-white font-bold rounded select-none bg-primary"
        onClick={() => handleSubmitSort()}
        id="product-sort-sheet-save-btn"
        data-testid="product-sort-sheet-save-btn"
      >
        SIMPAN
      </button>
    </BottomSheet>
  );
};
